import { combineReducers } from "redux";
import sessions from "./sessions";

export default combineReducers({
  sessions
});
